;(function(name,context,definition) { if (typeof module !== 'undefined' && module.exports) { module.exports = definition(); } else if (typeof define === 'function' && define.amd) { define(definition); } else { context[name] = definition(); } } ) ('Fingerprint', this, function() { 'use strict'; var Fingerprint = function(options) { var nativeForEach, nativeMap; nativeForEach = Array.prototype.forEach; nativeMap = Array.prototype.map; this.each = function(obj, iterator, context) { if (obj === null) { return; } if (nativeForEach && obj.forEach === nativeForEach) { obj.forEach(iterator, context); } else if (obj.length === +obj.length) { for (var i = 0, l = obj.length; i < l; i++) { if (iterator.call(context, obj[i], i, obj) === {}) return; } } else { for (var key in obj) { if (obj.hasOwnProperty(key)) { if (iterator.call(context, obj[key], key, obj) === {}) return; } } } }; this.map = function(obj, iterator, context) { var results = []; if (obj == null) return results; if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context); this.each(obj, function(value, index, list) { results[results.length] = iterator.call(context, value, index, list); }); return results; }; if (typeof options == 'object') { this.hasher = options.hasher; this.screen_resolution = options.screen_resolution; this.screen_orientation = options.screen_orientation; this.canvas = options.canvas; this.ie_activex = options.ie_activex; } else if (typeof options == 'function') { this.hasher = options; } }; Fingerprint.prototype = { get: function() { var keys = []; /*keys.push(new Date().getTime());*/ keys.push(navigator.userAgent); keys.push(navigator.language); keys.push(screen.colorDepth); if (this.screen_resolution) { var resolution = this.getScreenResolution(); if (typeof resolution !== 'undefined') { keys.push(this.getScreenResolution().join('x')); } } keys.push(new Date().getTimezoneOffset()); keys.push(this.hasSessionStorage()); keys.push(this.hasLocalStorage()); keys.push(!!window.indexedDB); if (document.body) { keys.push(typeof(document.body.addBehavior)); } else { keys.push(typeof undefined); } keys.push(typeof(window.openDatabase)); keys.push(navigator.cpuClass); keys.push(navigator.platform); keys.push(navigator.doNotTrack); keys.push(this.getPluginsString()); if (this.canvas && this.isCanvasSupported()) { keys.push(this.getCanvasFingerprint()); } if (this.hasher) { return this.hasher(keys.join('###'), 31); } else { return this.murmurhash3_32_gc(keys.join('###'), 31); } }, murmurhash3_32_gc: function(key, seed) { var remainder, bytes, h1, h1b, c1, c2, k1, i; remainder = key.length & 3; bytes = key.length - remainder; h1 = seed; c1 = 0xcc9e2d51; c2 = 0x1b873593; i = 0; while (i < bytes) { k1 = ((key.charCodeAt(i) & 0xff)) | ((key.charCodeAt(++i) & 0xff) << 8) | ((key.charCodeAt(++i) & 0xff) << 16) | ((key.charCodeAt(++i) & 0xff) << 24); ++i; k1 = ((((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16))) & 0xffffffff; k1 = (k1 << 15) | (k1 >>> 17); k1 = ((((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16))) & 0xffffffff; h1 ^= k1; h1 = (h1 << 13) | (h1 >>> 19); h1b = ((((h1 & 0xffff) * 5) + ((((h1 >>> 16) * 5) & 0xffff) << 16))) & 0xffffffff; h1 = (((h1b & 0xffff) + 0x6b64) + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16)); } k1 = 0; switch (remainder) { case 3: k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16; case 2: k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8; case 1: k1 ^= (key.charCodeAt(i) & 0xff); k1 = (((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff; k1 = (k1 << 15) | (k1 >>> 17); k1 = (((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff; h1 ^= k1; } h1 ^= key.length; h1 ^= h1 >>> 16; h1 = (((h1 & 0xffff) * 0x85ebca6b) + ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) & 0xffffffff; h1 ^= h1 >>> 13; h1 = ((((h1 & 0xffff) * 0xc2b2ae35) + ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16))) & 0xffffffff; h1 ^= h1 >>> 16; return h1 >>> 0; }, hasLocalStorage: function() { try { return !!window.localStorage; } catch (e) { return true; } }, hasSessionStorage: function() { try { return !!window.sessionStorage; } catch (e) { return true; } }, isCanvasSupported: function() { var elem = document.createElement('canvas'); return !!(elem.getContext && elem.getContext('2d')); }, isIE: function() { if (navigator.appName === 'Microsoft Internet Explorer') { return true; } else if (navigator.appName === 'Netscape' && /Trident/.test(navigator.userAgent)) { return true; } return false; }, getPluginsString: function() { if (this.isIE() && this.ie_activex) { return this.getIEPluginsString(); } else { return this.getRegularPluginsString(); } }, getRegularPluginsString: function() { return this.map(navigator.plugins, function(p) { var mimeTypes = this.map(p, function(mt) { return [mt.type, mt.suffixes].join('~'); }).join(','); return [p.name, p.description, mimeTypes].join('::'); }, this).join(';'); }, getIEPluginsString: function() { if (window.ActiveXObject) { var names = ['ShockwaveFlash.ShockwaveFlash', 'AcroPDF.PDF', 'PDF.PdfCtrl', 'QuickTime.QuickTime', 'rmocx.RealPlayer G2 Control', 'rmocx.RealPlayer G2 Control.1', 'RealPlayer.RealPlayer(tm) ActiveX Control (32-bit)', 'RealVideo.RealVideo(tm) ActiveX Control (32-bit)', 'RealPlayer', 'SWCtl.SWCtl', 'WMPlayer.OCX', 'AgControl.AgControl', 'Skype.Detection' ]; return this.map(names, function(name) { try { new ActiveXObject(name); return name; } catch (e) { return null; } }).join(';'); } else { return ""; } }, getScreenResolution: function() { var resolution; if (this.screen_orientation) { resolution = (screen.height > screen.width) ? [screen.height, screen.width] : [screen.width, screen.height]; } else { resolution = [screen.height, screen.width]; } return resolution; }, getCanvasFingerprint: function() { var canvas = document.createElement('canvas'); var ctx = canvas.getContext('2d'); var txt = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$%^&*()_+-={}|[]\:"<>?;,.'; ctx.textBaseline = "top"; ctx.font = "14px 'Arial'"; ctx.textBaseline = "alphabetic"; ctx.fillStyle = "#f60"; ctx.fillRect(125, 1, 62, 20); ctx.fillStyle = "#069"; ctx.fillText(txt, 2, 15); ctx.fillStyle = "rgba(102, 204, 0, 0.7)"; ctx.fillText(txt, 4, 17); return canvas.toDataURL(); } }; return Fingerprint;});
class HallmarkUser {
  constructor(customer_id, user_cart) {
    this.settings = {
      api: {
        url: 'https://services.hallmark.co.uk/',
        identity: 'auth-token/',
        customization: 'customization/',
        migrate: '/migrate'
      },
      expiry: {
        token: 7200,
        refresh: 604800,
        fingerprint: 60 * 60 * 24 * 7, // 1 week to expire
        projects_migrated: 60 * 60 * 24 * 365, // 1 year to expire
      }
    }
    var _this = this;
    this.fingerprint = this._getFingerprint()
    this.jwt = getCookie('jwt');
    this.jwt_refresh = getCookie('jwt_refresh');
    this.user_cart = user_cart;
    this.project_ids = [];
    if( this.user_cart ) {
      this.user_cart.forEach(function(project){
        if( project.properties && project.properties['_project_id'] ) {
          _this.project_ids.push(project.properties['_project_id']);
        }
      });
    }
    this.fresh_login = (customer_id && ( sessionStorage.getItem('register_page') || sessionStorage.getItem('login_page') ) && window.location.pathname.indexOf('/challenge') == -1) ? true : false;
    if (customer_id) {
      this.id = '' + customer_id + '';
      this.accountType = 'R'
    } else {
      this.id = this.fingerprint;
      this.accountType = 'G';
    }
    setCookie('accountId', this.id, this.settings.expiry.fingerprint);
    setCookie('accountType', this.accountType, this.settings.expiry.fingerprint);

    setTimeout(function(){
      if( _this.fresh_login ) {
        if( _this.project_ids && _this.project_ids.length > 0 ) {
          _this._getToken('login');
          //_this._migrateProjects();
        } else {
          _this._getToken();
        }
      } else if ( !_this.jwt || !_this.jwt_refresh ) {
        _this._getToken();
      }
      _this._multishipCart();
      _this._checkTokenExpiry();
    }, 300);
  }

  _newTokenData(){
    return {
      "path": "account-token",
      "headers": {
        // prod
        "Authorization": "Basic YTI5Nzc4OWItNTU4OS00MDc4LTk4YjktNzg4ODc1YTJmNWFmOjJjZTk2MmQ3LWM0NmQtNDQ4OS04ZDYyLWQzZTA1ZGFiZThjZg=="
      },
      "body": {
        "account_id": this.id,
        "account_type": this.accountType == 'R' ? 'registered' : 'guest',
        "expires_in": this.settings.expiry.token,
        "refresh_expires_in": this.settings.expiry.refresh
      }
    }
  }
  _refreshTokenData(){
    return {
      "path": "refresh",
      "headers": {
        "Authorization": "Bearer " + localStorage.getItem('previous_refresh_token'),
      },
      "body": ""
    }
  }
  _migrateProjectsData(){
    return {
      "path": "migrate",
      "headers": {
        "Authorization": "Bearer " + getCookie('jwt')
      },
      "body": {
        "guest_account_id": this.fingerprint,
        "project_ids": this.project_ids
      }
    }
  }

  _getFingerprint(){
    if ( getCookie('user_fingerprint') && getCookie('user_fingerprint') != 'false' ) {
      return getCookie('user_fingerprint');
    }
    var fp = new Fingerprint({});
    var uid = String('0' + fp.get() + new Date().getTime());
    //var uid = fp.get();
    //console.log('NEW FINGERPRINT', uid);
    setCookie('user_fingerprint', uid, this.settings.expiry.fingerprint);
    return uid
  }
  _getRequestHeaders(postData){
    var headers = postData['headers'] || {};
    if( !headers['Content-Type'] ) {
      headers['Content-Type'] = 'application/json; charset=UTF-8';
    }
    return headers
  }
  _getToken(type){
    //if( type == 'refresh' || (this.jwt_refresh && !this.jwt) ) {
    if( type == 'refresh' || (this.jwt_refresh && this.jwt) ) {
      //console.log('GET REFRESH TOKEN')
      // console.log(type);
      // console.log(this.jwt_refresh);
      // console.log(this.jwt);
      var postData = this._refreshTokenData();
    } else {
      //console.log('GET FRESH TOKEN')
      var postData = this._newTokenData();
    }
    fetch(this.settings.api.url + this.settings.api.identity + postData['path'], {
      method: "POST",
      body: JSON.stringify(postData['body']),
      headers: this._getRequestHeaders(postData)
    })
    .then(response => response.json())
    .then(json => {
      if( json && json.data ) {
        //console.log('TOKEN RESPONSE', json.data)
        var accessToken = json.data['access_token'];
        if( accessToken ) {
          var expiresIn = this.settings.expiry.token;
          if( json.data['expires_in'] ) {
            expiresIn = parseInt( json.data['expires_in'] )
          }
          this.jwt = accessToken;
          setCookie('jwt', accessToken, expiresIn);
          setCookie('jwt_expires', expiryDate(json.data['expires_in']), expiresIn);
        }
        var refreshToken = json.data['refresh_token'];
        if( refreshToken ) {
          var refreshExpiresIn = this.settings.expiry.refresh;
          if( json.data['refresh_expires_in'] ) {
            refreshExpiresIn = parseInt( json.data['refresh_expires_in'] )
          }
          this.jwt_refresh = refreshToken;
          setCookie('jwt_refresh', refreshToken, refreshExpiresIn);
          setCookie('jwt_refresh_expires', expiryDate(json.data['refresh_expires_in']), refreshExpiresIn);
        }
        if(type == 'login') {
          this._migrateProjects();
        } else {
          sessionStorage.removeItem('register_page');
          sessionStorage.removeItem('login_page');      
        }

        localStorage.setItem('previous_access_token', accessToken);
        localStorage.setItem('previous_refresh_token', refreshToken);
      }
    });
  }
  _checkTokenExpiry(){
    if( getCookie('jwt_expires') ) {
      var d1 = new Date(getCookie('jwt_expires')),
          d2 = new Date();
      var diff = (d1.getTime() - d2.getTime());
      var minutes = Math.abs(Math.round(diff/60/1000));
      if( minutes < 3 ) {
        setTimeout(function(){
          this._getToken('refresh');
        }, diff + 10);
      }
    }
  }
  _multishipCart(){
    var _this = this;
    if( window.location.pathname.indexOf('/cart') > -1 ) {
      //console.log('pathname has gs cart');
      if( document.querySelector('.cart-item.personalised') ) {
        //console.log('cart has gs line item');
        _this._updateProjectCustomData();
      } else {
        //console.log('cart does not have gs line item');
        
        // window.addEventListener("custom:multiship", function(e){
          setTimeout(function(){
            //console.log('timeout adding event listener');
            _this._updateProjectCustomData();
          }, 1200);
        // });
      }
    }
  }
  _updateProjectCustomData(){
    //console.log('updateProjectCustomData');
    var _this = this;
    // var cart_items = document.querySelectorAll('.gs__line[data-line]');
    var cart_items = document.querySelectorAll('.cart-item');
    cart_items.forEach(function(cart_item){
      //console.log('each cart item');
      var line = parseInt(cart_item.getAttribute('data-line')) || false;
      var img_wrap = cart_item.querySelector('.cart-item__image');
      var img = cart_item.querySelector('.cart-item__image img');
      var img_src = cart_item.querySelector('.cart-item__image img');
      //console.log('img_src ' + img_src.src);
      var line_item = _this.user_cart[line-1];
      var count = 0;
      // console.log(line_item);
      if( line_item && line_item['properties'] ) {
        /*
        if( cart_item.querySelector('.ms__saved-address') && line_item['properties']['Address'] ) {
          console.log('update', cart_item.querySelector('.ms__saved-address'), 'with address', line_item['properties']['Address'] );
          cart_item.querySelector('.ms__saved-address').value = line_item['properties']['Address'];
        }
        */
        if( line_item['properties']['_project_id'] ) {
          //console.log('asd!')
          // var edit_link = document.createElement('a');
          // edit_link.setAttribute('href', 'https://www.cards.hallmark.co.uk/card/customization/edit/' + line_item['properties']['_project_id']);
          // edit_link.classList.add('project-edit');
          // edit_link.classList.add('project-edit' + count);
          // edit_link.innerHTML = 'Edit';
          // cart_item.querySelector('.small-text').appendChild(edit_link);
          // cart_item.querySelector('.gs__address-wrapper').classList.add('disabled');
          // cart_item.querySelector('.gs__qty-wrapper').classList.add('disabled');
          
        }
        if( line_item['properties']['_thumbnail'] ) {
          //console.log('contains thumbnail?');
          img.setAttribute('src', line_item['properties']['_thumbnail']);
          img.addEventListener('load', function(){
            img_wrap.classList.add('loaded');
          }, {
            once: true
          });
        } 
        else{
          // console.log('does not contain thumbnail');
         
          var variant_img = 'https://www.hallmark.co.uk/cdn/shop/' + img_src.src;
          //console.log('variant img');
          //console.log(variant_img);
          if(variant_img.indexOf("_hand_S" !== -1)){
            //console.log('hand_s');
            var prod_img = variant_img.replace("_hand_S", "_hero");
          }
          else if(variant_img.indexOf("_hand_L" !== -1)){
            //console.log('hand_l');
            var prod_img = variant_img.replace("_hand_L", "_hero");
          }
          else{
            //console.log('no hand');
            var prod_img = variant_img;
          }
          
          
          //console.log(prod_img);
          
           //img.setAttribute('src',  prod_img);
          //change image url dynamically
          // console.log(img.attr('arc'));
          img_wrap.classList.add('loaded');
        }
      }
      else{
          //console.log('does not contain properties');
          img_wrap.classList.add('loaded');
      }
      if( document.querySelector('gs__cart-meta .project-edit:first-of-type') ) {
        document.querySelector('gs__cart-meta .project-edit:first-of-type').style.display = 'none'
      }
    })
  }
  _migrateProjects(){
    var postData = this._migrateProjectsData();
    fetch(this.settings.api.url + this.settings.api.customization + this.id + '/' + postData['path'], {
      method: "PATCH",
      body: JSON.stringify(postData['body']),
      headers: this._getRequestHeaders(postData)
    })
    .then(response => response.json())
    .then(json => {
      //console.log('PROJECTS ' + this.project_ids + ' MIGRATED FROM FINGERPRINT ' + this.fingerprint + ' TO ' + this.id );
      //console.log('WITH RESULT:', json.meta.code, json);
      sessionStorage.removeItem('register_page');
      sessionStorage.removeItem('login_page');
      setCookie('projects_migrated', JSON.stringify(this.project_ids), this.settings.expiry.projects_migrated);
    });
  }
}